import { render, staticRenderFns } from "./vwowtest.vue?vue&type=template&id=c3fa74e8&"
import script from "./vwowtest.vue?vue&type=script&lang=js&"
export * from "./vwowtest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports